import InputArea from './inputArea';
import QAVStore from './qavStore';
import InputTelephoneNum from '../../views/inputTelephoneNum/index';

export interface InputTelephoneNumStoreModel {
    inputArea: InputArea;
    qav: QAVStore;
}

class RootStore implements InputTelephoneNumStoreModel {
    public inputArea: InputArea;
    public qav: QAVStore;
    public constructor() {
        this.inputArea = new InputArea(this);
        this.qav = new QAVStore(this);
    }
}

export default new RootStore();
